<template>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h2 class="modal-title" v-if="doc.url">Редактировать инструкцию</h2>
        <h2 class="modal-title" v-else>Добавить инструкцию</h2>
      </div>
      <div class="modal-body">
        <form>
          <input type="file" v-if="!doc.url" @change="onFileChange" class="mb-3">
          <div class="form-group">
            <input type="text" v-model="doc.name" class="form-control" id="name"
                   :placeholder="doc.name ?  doc.name :'Введите название'">
          </div>
          <h6>Отображать для:</h6>
          <div class="row">
            <div class="col-md">
              <div class="custom-control custom-checkbox">
                <input class="custom-control-input" v-model="doc.roles.service" type="checkbox" value="" :id="`checkbox-${_uid}-service`">
                <label class="custom-control-label" :for="`checkbox-${_uid}-service`">Оператор</label>
              </div>
              <div class="custom-control custom-checkbox">
                <input class="custom-control-input" v-model="doc.roles.service_superior" type="checkbox" value="" :id="`checkbox-${_uid}-service_superior`">
                <label class="custom-control-label" :for="`checkbox-${_uid}-service_superior`">Руководитель операторов</label>
              </div>
            </div>
            <div class="col-md">
              <div class="custom-control custom-checkbox">
                <input class="custom-control-input" v-model="doc.roles.tech" type="checkbox" value="" :id="`checkbox-${_uid}-tech`">
                <label class="custom-control-label" :for="`checkbox-${_uid}-tech`">Техник</label>
              </div>
              <div class="custom-control custom-checkbox">
                <input class="custom-control-input" v-model="doc.roles.tech_superior" type="checkbox" value="" :id="`checkbox-${_uid}-tech_superior`">
                <label class="custom-control-label" :for="`checkbox-${_uid}-tech_superior`">Руководитель техников</label>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <btn-action class="btn btn-primary" @click="save">Сохранить</btn-action>
      </div>
    </div>
  </div>
</template>

<script>
  import api from '@/api'

  export default {
    data: () => ({
      doc: {
        name: '',
        file: {},
        roles: {
          service: false,
          service_superior: false,
          tech: false,
          tech_superior: false,
        },
      },
    }),
    props: ['currentDoc'],
    mounted () {
      if (this.currentDoc != null) {
        this.doc = this.currentDoc
      }
    },
    methods: {
      onFileChange (e) {
        const files = e.target.files || e.dataTransfer.files
        if (!files.length) {
          return
        }
        this.doc.file = files[0]
      },
      save () {
        if (this.doc.name === '') {
          alert('Введите имя')
          return
        }
        if (this.doc.id == null) {
          const data = new FormData()
          data.append('doc', this.doc.file)
          data.append('name', this.doc.name)
          data.append('roles', JSON.stringify(this.doc.roles))

          const headers = {'content-type': 'multipart/form-data'}
          return api.post('documents', data, {headers}).then(() => this.$emit('hide', true))
        } else {
          return api.put(`documents/${this.doc.id}`, {
            'id': this.doc.id,
            'roles': this.doc.roles,
            'name': this.doc.name,
          }).then(() => this.$emit('hide', true))
        }
      },
    },
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/documents-modal.vue